import React from 'react';
import { Transition } from 'react-transition-group'
import PropTypes from 'prop-types';


const duration = 1000
// const sidebarStyle = {
//   transition: `width ${duration}ms`
// }
// const sidebarTransitionStyles = {
//   entering: { width: 0 },
//   entered: { width: '200px' },
//   exiting: { width: '200px' },
//   exited: { width: 0 }
// }
const linkStyle = {
  transition: `width ${duration}ms`
}
const linkTransitionStyles = {
    entering: { width: 0 },
      entered: { width: '200px' },
      exiting: { width: '200px' },
      exited: { width: 0 }
}
const Stransition = ({children, isOpen}) => {
    return (
    <Transition in={isOpen} timeout={duration}>
        {(state) => (
            <div style={{
            ...linkStyle,
            ...linkTransitionStyles[state]
            }}>
                {children}
            </div>
        )}
    </Transition>
    );
}
Stransition.propTypes = {
    children: PropTypes.node.isRequired,
    isOpen: PropTypes.bool.isRequired
  };
export default Stransition;
